import { helper } from '@ember/component/helper';

import attachToStrings from 'rise-ui/utils/attach-to-strings.js';
import { split } from 'rise-ui/utils/string.js';
import { isSet } from 'rise-ui/utils/nullish.js';

const getDelimitedProps = (...props) => {
  const result = [];
  props.forEach(prop => {
    if (prop) {
      result.push(...split(prop, ' '));
    }
  });
  return result;
};

const defaultPrefix = '--';
const defaultSuffix = '';

/**
 * @interface ClassModsConfig
 * @property {string} [prefix]
 * @property {string} [suffix]
 * @property {string} [modifiers]
 */

/**
 * @interface ClassModsOptions
 * @implements ClassModsConfig
 * @property {ClassModsConfig} [config]
 */

/**
 * Outputs aggregate array of modifiers with various affixes for consumption by class-mod modifiers parameter
 * @param {array} modifiers Flat pairs of activation flag and modifier string
 *   it activates (e.g. [ true, '--enabled', false, '--disabled', ... ])
 * @param {ClassModOptions} hash
 * @return {array} Flat pairs of true activation flag and modifier string
 *   it activates (e.g. [ true, '--enabled', ... ])
 */
export default helper(function classModsHelper([ ...modifiers ], hash) {
  hash = hash || {};
  const config = hash.config || {};
  const hasPrefix = isSet(hash.prefix) || isSet(config.prefix);
  const hasSuffix = isSet(hash.suffix) || isSet(config.suffix);
  const prefix = hasPrefix ? getDelimitedProps(hash.prefix, config.prefix).join('') : defaultPrefix;
  const suffix = hasSuffix ? getDelimitedProps(hash.suffix, config.suffix).join('') : defaultSuffix;
  modifiers = getDelimitedProps(...modifiers, ...(config.modifiers || []) , ...(hash.modifiers || []));
  modifiers = attachToStrings(modifiers, { prefix, suffix, inclusive: false /* only return modified strings */ });
  const result = [];
  modifiers.forEach(modifier => {
    result.push(true);
    result.push(modifier);
  });
  return result;
});
